import * as indexApi from "@/api/indexApi";
const state = {
    seoData: {

    }
}
const mutations = {
    SET_SEO: (state, data) => {
        state.seoData = data
    }
}
const actions = {
    // seo
    async getSeo({ commit }, params) {
        let par = {
            type: 'INDEX',
            relevantPage: params
        }
        const data = await indexApi.getSeo(par)
        console.log('seo', data.data.data)

        if (data.data.code == 200) {
            if (data.data.data) {
                commit('SET_SEO', data.data.data)
            } else {
                let par = {
                    title: '房屋装修监理管理平台',
                    keyword: '杭州装修监理 杭州家装监理 家装第三方监理 杭州精装修验房公司 浙江旭尧监理 监管现场 装修监管平台 房屋装修监理管理平台',
                    describe: '房屋装修监理管理平台是由浙江旭尧监理创办的线上装修管家服务平台，业主可通过平台时刻查看装修进度和施工质量情况,同时可在线咨询装修疑难问题，规避装修陷阱！'
                }
                commit('SET_SEO', par)
            }
        }
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/seo.js